export default "__VITE_ASSET__3336af35__"